import React from "react"
import { Flex, FlexProps, Text } from "@chakra-ui/core"
import { FluidObject } from "gatsby-image"
import FluidImage from "../FluidImage"
import FormattedTitle from "../FormattedTitle"
import Body from "../typography/Body"
import IconButton from "../Buttons/IconButton"
import animations from "../../constants/animations"

export type CompareItemProps = FlexProps & {
  bike?: {
    id: string
    image: FluidObject
    title: string
    price: string
  }
  onClose: VoidFunction
}

export default function CompareItem({
  bike,
  onClose,
  ...props
}: CompareItemProps) {
  return (
    <Flex
      backgroundColor="white"
      opacity={bike ? 1 : 0.1}
      transition={`opacity 200ms ${animations.bezier}`}
      borderRadius="0.5rem"
      {...props}
    >
      {bike && (
        <>
          <Flex pt="0.7244rem" pb="0.6181rem" pl="0.8806rem" flexGrow={1}>
            <FluidImage
              d="flex"
              alignItems="center"
              image={bike.image}
              width="6.25rem"
              mr="1rem"
            />
            <Flex flexDir="column" justify="center" flexGrow={1}>
              <Text
                fontFamily="heading"
                color="night"
                mb="0.5rem"
                lineHeight="1rem"
              >
                <FormattedTitle raw={bike.title} />
              </Text>
              <Body color="dawn">{bike.price}</Body>
            </Flex>
          </Flex>
          <IconButton
            icon="close"
            aria-label="Remove bike from compare"
            backgroundColor="transparent"
            maxWidth="4.3125rem"
            height="100%"
            borderLeft="1px solid"
            borderColor="dividerLine"
            color="dawn"
            borderRadius="0 0.5rem 0.5rem 0"
            onClick={onClose}
          />
        </>
      )}
    </Flex>
  )
}
